import BaseBankLogo, { BaseBankLogoProps, BankLogoConfig } from './BaseBankLogo';

type AmexLogoProps = Omit<BaseBankLogoProps, 'config' | 'renderLogo'>;

const amexConfig: BankLogoConfig = {
    colors: {
        background: '#016FD0',
        logo: 'white',
    },
    defaultAlt: 'American Express Logo',
};

const renderAmexLogo = (colors: { background: string; border?: string; logo: string }) => (
    <>
        <path
            d="M12.3906 43.5788V33.5557H23.0033L24.1419 35.04L25.3182 33.5557H63.8396V42.8876C63.8396 42.8876 62.8321 43.5688 61.667 43.5788H40.337L39.0532 41.9988V43.5788H34.8465V40.8817C34.8465 40.8817 34.2718 41.2582 33.0294 41.2582H31.5976V43.5788H25.2282L24.0912 42.0627L22.9367 43.5788H12.3906Z"
            fill={colors.logo}
        />
        <path
            d="M0 26.0003L2.3932 20.4209H6.53198L7.89015 23.5462V20.4209H13.035L13.8436 22.6798L14.6274 20.4209H37.7226V21.5565C37.7226 21.5565 38.9367 20.4209 40.932 20.4209L48.4256 20.4471L49.7603 23.5315V20.4209H54.0658L55.2508 22.1927V20.4209H59.5958V30.444H55.2508L54.1152 28.6665V30.444H47.7894L47.1533 28.864H45.4527L44.8269 30.444H40.537C38.8201 30.444 37.7226 29.3316 37.7226 29.3316V30.444H31.2545L29.9707 28.864V30.444H5.91885L5.28314 28.864H3.58799L2.95678 30.444H0V26.0003Z"
            fill={colors.logo}
        />
        <path
            d="M3.23962 21.6572L0.0117188 29.1623H2.11325L2.70884 27.6594H6.17127L6.76377 29.1623H8.91159L5.68678 21.6572H3.23962ZM4.43388 23.4039L5.48928 26.03H3.3754L4.43388 23.4039Z"
            fill={colors.background}
        />
        <path
            d="M9.13281 29.1603V21.6553L12.1192 21.6664L13.8562 26.5051L15.5516 21.6553H18.5141V29.1603H16.6378V23.6303L14.649 29.1603H13.0035L11.0091 23.6303V29.1603H9.13281Z"
            fill={colors.background}
        />
        <path
            d="M19.7988 29.1603V21.6553H25.9213V23.334H21.6948V24.6178H25.8226V26.1978H21.6948V27.5309H25.9213V29.1603H19.7988Z"
            fill={colors.background}
        />
        <path
            d="M27.0059 21.6572V29.1623H28.8821V26.496H29.6721L31.9218 29.1623H34.2146L31.7459 26.3972C32.7591 26.3117 33.8042 25.4421 33.8042 24.092C33.8042 22.5127 32.5646 21.6572 31.1811 21.6572H27.0059ZM28.8821 23.336H31.0269C31.5413 23.336 31.9156 23.7384 31.9156 24.126C31.9156 24.6246 31.4307 24.916 31.0546 24.916H28.8821V23.336Z"
            fill={colors.background}
        />
        <path d="M36.488 29.1603H34.5723V21.6553H36.488V29.1603Z" fill={colors.background} />
        <path
            d="M41.0295 29.1603H40.6159C38.6152 29.1603 37.4004 27.584 37.4004 25.4386C37.4004 23.2403 38.6016 21.6553 41.1282 21.6553H43.202V23.4328H41.0524C40.0267 23.4328 39.3013 24.2332 39.3013 25.4572C39.3013 26.9106 40.1308 27.521 41.3257 27.521H41.8195L41.0295 29.1603Z"
            fill={colors.background}
        />
        <path
            d="M45.1127 21.6572L41.8848 29.1623H43.9863L44.5819 27.6594H48.0443L48.6368 29.1623H50.7846L47.5598 21.6572H45.1127ZM46.3069 23.4039L47.3623 26.03H45.2484L46.3069 23.4039Z"
            fill={colors.background}
        />
        <path
            d="M51.002 29.1603V21.6553H53.3874L56.4332 26.3706V21.6553H58.3095V29.1603H56.0012L52.8782 24.3215V29.1603H51.002Z"
            fill={colors.background}
        />
        <path
            d="M13.6758 42.2941V34.7891H19.7983V36.4678H15.5718V37.7516H19.6996V39.3316H15.5718V40.6647H19.7983V42.2941H13.6758Z"
            fill={colors.background}
        />
        <path
            d="M43.6758 42.2941V34.7891H49.7983V36.4678H45.5718V37.7516H49.6798V39.3316H45.5718V40.6647H49.7983V42.2941H43.6758Z"
            fill={colors.background}
        />
        <path
            d="M20.0358 42.2941L23.0168 38.5879L19.9648 34.7891H22.3287L24.1463 37.1375L25.9701 34.7891H28.2414L25.2295 38.5416L28.216 42.2941H25.8525L24.0877 39.9827L22.3657 42.2941H20.0358Z"
            fill={colors.background}
        />
        <path
            d="M28.4375 34.791V42.296H30.3631V39.926H32.3381C34.0093 39.926 35.276 39.0395 35.276 37.3153C35.276 35.887 34.2825 34.791 32.5819 34.791H28.4375ZM30.3631 36.4883H32.4431C32.9829 36.4883 33.3688 36.8192 33.3688 37.3524C33.3688 37.8532 32.9849 38.2164 32.4369 38.2164H30.3631V36.4883Z"
            fill={colors.background}
        />
        <path
            d="M36.0918 34.7891V42.2941H37.9681V39.6278H38.7581L41.0077 42.2941H43.3006L40.8318 39.5291C41.845 39.4436 42.8901 38.574 42.8901 37.2239C42.8901 35.6446 41.6506 34.7891 40.2671 34.7891H36.0918ZM37.9681 36.4678H40.1128C40.6273 36.4678 41.0015 36.8703 41.0015 37.2578C41.0015 37.7564 40.5166 38.0478 40.1406 38.0478H37.9681V36.4678Z"
            fill={colors.background}
        />
        <path
            d="M50.6679 42.2941V40.6647H54.4229C54.9785 40.6647 55.2191 40.3645 55.2191 40.0352C55.2191 39.7197 54.9793 39.4007 54.4229 39.4007H52.7261C51.2511 39.4007 50.4297 38.5021 50.4297 37.1529C50.4297 35.9495 51.1819 34.7891 53.3737 34.7891H57.0274L56.2374 36.4777H53.0774C52.4734 36.4777 52.2874 36.7947 52.2874 37.0974C52.2874 37.4085 52.5172 37.7516 52.9787 37.7516H54.7562C56.4004 37.7516 57.1139 38.6842 57.1139 39.9056C57.1139 41.2186 56.3188 42.2941 54.6667 42.2941H50.6679Z"
            fill={colors.background}
        />
        <path
            d="M57.5527 42.2941V40.6647H61.3077C61.8633 40.6647 62.1038 40.3645 62.1038 40.0352C62.1038 39.7197 61.864 39.4007 61.3077 39.4007H59.6108C58.1359 39.4007 57.3145 38.5021 57.3145 37.1529C57.3145 35.9495 58.0667 34.7891 60.2584 34.7891H63.9122L63.1222 36.4777H59.9622C59.3581 36.4777 59.1722 36.7947 59.1722 37.0974C59.1722 37.4085 59.402 37.7516 59.8634 37.7516H61.641C63.2852 37.7516 63.9986 38.6842 63.9986 39.9056C63.9986 41.2186 63.2036 42.2941 61.5514 42.2941H57.5527Z"
            fill={colors.background}
        />
    </>
);

/**
 * American Express logo component with flexible sizing and color variants
 */
function AmexLogo(props: AmexLogoProps) {
    return <BaseBankLogo {...props} config={amexConfig} renderLogo={renderAmexLogo} />;
}

export default AmexLogo;
